// extracted by mini-css-extract-plugin
export default {"subtypesSelect":"styles_subtypes-select__8QuQi"};